import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

interface ReleaseNote {
  version: string;
  date: string;
  highlights: string[];
  details?: string;
}

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrl: './release-notes.component.scss'
})
export class ReleaseNotesComponent implements OnInit {

  appVersion: string = '';
  plannedOutage: string = ''
  
  notes: ReleaseNote[] = [
    {
      version: '1.8.0.2',
      date: 'October 2025',
      highlights: [
        'Better support hebrew in MyQuest intro',
        'Bug fixes and stability improvements'
      ],
      details: 'This release focused on bug fixes and performance improvements'
    },
    {
      version: '1.8.0.1',
      date: 'October 2025',
      highlights: [
        'Overhauled the competencies flow in MyQuest',
        'Ux improvements and bug fixes'
      ]
    },
    {
      version: '1.8.0.0',
      date: 'August 2025',
      highlights: [
        'Added support for MyQuest - Alpha',
        'Allow users to test the MyQuest feature',
        'Overhauled prompt creation flow'
      ]
    }
  ];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.plannedOutage = 'No outage is currently planned';
    this.http.get<{ version: string }>('/assets/common/config.json').subscribe({
      next: (config) => (this.appVersion = config.version),
      error: (err) => console.error('Failed to load config.json', err)
    });
  }
}